export default __webpack_public_path__ + "static/media/OTWORZ.e8705cb9.svg";